export default "__VITE_ASSET__YX2s9Jpu__ 584w";